/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_PartiesInputs */

const cs_draft_group_parties = /** @type {(inputs: Draft_Group_PartiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strany`)
};

const en_draft_group_parties = /** @type {(inputs: Draft_Group_PartiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parties`)
};

/**
* | output |
* | --- |
* | "Parties" |
*
* @param {Draft_Group_PartiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_parties = /** @type {((inputs?: Draft_Group_PartiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_PartiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_parties(inputs)
	return cs_draft_group_parties(inputs)
});